import React from 'react';
import { Input } from './input';
import { cn } from '../../lib/utils';
import {
  DATE_MIN,
  DATE_MAX,
  sanitizeDateValue,
} from '../../utils/dateValidation';

export default function DateInput({
  value,
  onChange,
  error,
  className,
  id,
  required,
  disabled,
  min = DATE_MIN,
  max = DATE_MAX,
  ...props
}) {
  const handleChange = (e) => {
    const sanitized = sanitizeDateValue(e.target.value);
    if (sanitized === null) return;
    onChange?.(sanitized);
  };

  return (
    <div className="space-y-1">
      <Input
        id={id}
        type="date"
        min={min}
        max={max}
        value={value ?? ''}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={cn(error && 'border-destructive focus-visible:ring-destructive', className)}
        aria-invalid={Boolean(error)}
        {...props}
      />
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
